import React, { createRef, useEffect, useRef, useState } from "react";
import { useTheme } from "styled-components";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Button } from "@wrstudios/components";
import { IconTrashCan, IconPlus, IconClosePill } from "@wrstudios/icons";
import IconDrag from "../../icons/IconDrag";
import {
  deleteSubjectPropertyPhoto,
  updateSubjectProperty
} from "../../../api/subject-property";
import { useLive } from "../LiveProvider";
import { transformSubjectProperty } from "../../../utils/subject-property";
import {
  PhotoCell,
  Input,
  MapStatic
} from "./styled/live-listing-subject-property";
import PhotoSelector from "../../common/PhotoSelector";
import { ComparableAddress } from "../../comparable";
import {
  DrawerContent,
  DrawerHeader,
  ActiveList,
  PhotoWidgetContainer,
  PhotoCellContainer,
  DeleteWrapper,
  ResetToDefaultContainer
} from "./styled/live-listing-subject-property-drawer";
import SubjectPropertyPin from "../../common/SubjectPropertyPin";
function LiveListingSubjectPropertyDrawer({
  comparisonFields,
  setComparisonFields,
  activeFields,
  setActiveFields,
  setInactiveFields,
  inactiveFields,
  setShowEditDrawer,
  activeUpdate,
  updateFromModal,
  setActiveUpdate,
  setLoading,
  setToasterMessage,
  setUpdateFromModal
}) {
  const theme = useTheme();

  const { report, subjectProperty, setSubjectProperty } = useLive();
  const [activeSearchBox, setActiveSearchBox] = useState(false);
  const [activeReset, setActiveReset] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const activeFieldsDefault = JSON.parse(JSON.stringify(activeFields));
  const inactiveFieldsDefault = JSON.parse(JSON.stringify(inactiveFields));
  const [activeFieldsState, setActiveFieldsState] =
    useState(activeFieldsDefault);
  const [inactiveFieldsState, setInactiveFieldsState] = useState(
    inactiveFieldsDefault
  );
  const detectOutClickRef = createRef();
  const textInput = useRef(null);
  const searchWrapperRef = useRef(null);
  const [photo, setPhoto] = useState(null);
  const [cropData, setCropData] = useState(null);
  const [resetConfirm, setConfirmReset] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [photoExists, setPhotoExists] = useState(
    subjectProperty.photo === "" || !subjectProperty.photo ? false : true
  );
  const [updateReset, setUpdateReset] = useState(false);
  const keepRow = () => {
    setConfirmDelete(null);
  };

  const removeRow = (index) => {
    const selectedItem = activeFieldsState.splice(index, 1);
    setInactiveFieldsState((inactiveFieldsState) =>
      [...inactiveFieldsState, ...selectedItem].sort((a, b) => {
        let x = a.columnName.toUpperCase(),
          y = b.columnName.toUpperCase();
        return x == y ? 0 : x > y ? 1 : -1;
      })
    );

    let selectedItemComparisionFields;
    const comparisonfield = comparisonFields.map((obj) => {
      if (obj.columnName === selectedItem[0].columnName) {
        obj.isActive = false;
        obj["isTemp"] = false;
        selectedItemComparisionFields = obj;
      }
      return obj;
    });

    const newComparisonField = comparisonfield.concat(
      comparisonfield.splice(
        comparisonfield.indexOf(selectedItemComparisionFields),
        1
      )
    );
    setComparisonFields(newComparisonField);

    //  Get the selected item and remove from inactiveFieldsState.
    setActiveReset(true);
    setActiveUpdate(true);
    setConfirmDelete(null);
  };

  useEffect(() => {
    subjectProperty.photo ? setPhotoExists(true) : setPhotoExists(false);
  }, []);

  // State to store searches.

  useDetectOutClick(detectOutClickRef, () => {
    setActiveSearchBox(false);
  });

  const deletefromActiveList = (index) => {
    setConfirmDelete(index);
  };

  const resetToDefault = () => {
    setConfirmReset(true);
  };

  const handleCancelReset = () => {
    setConfirmReset(false);
  };

  const handleConfirmReset = () => {
    const allfields = activeFields.concat(inactiveFields);
    for (let i = 0; i < allfields.length; i++) {
      if (allfields[i].columnName == "beds") allfields[i].isActive = true;
      else if (allfields[i].columnName == "baths") allfields[i].isActive = true;
      else if (allfields[i].columnName == "sqft") allfields[i].isActive = true;
      else if (allfields[i].columnName == "lot_size")
        allfields[i].isActive = true;
      else if (allfields[i].columnName == "garages")
        allfields[i].isActive = true;
      else allfields[i].isActive = false;
    }
    setActiveFieldsState(allfields.filter((obj) => obj.isActive));
    setInactiveFieldsState(allfields.filter((obj) => !obj.isActive));
    setUpdateReset(true);
  };

  const handleCancel = () => {
    setComparisonFields(
      comparisonFields.map((obj) => {
        if (obj.isDraft === true) {
          obj.isActive = false;
          obj.isDraft = false;
          obj["isTemp"] = false;
        }
        return obj;
      })
    );

    setShowEditDrawer(false);
    setActiveUpdate(false);
  };

  const pushToActive = (index) => {
    if (searchResults) {
      const selectedItem = searchResults.splice(index, 1);

      const indexInactive = inactiveFieldsState.indexOf(selectedItem[0]);
      inactiveFieldsState.splice(indexInactive, 1);

      setActiveFieldsState((activeFieldsState) => [
        ...activeFieldsState,
        ...selectedItem
      ]);

      setComparisonFields(
        comparisonFields.map((obj) => {
          if (obj.columnName === selectedItem[0].columnName) {
            obj.isActive = true;
            obj.isDraft = true;
            obj["isTemp"] = true;
          }
          return obj;
        })
      );
      setTimeout(() => {
        setComparisonFields(
          comparisonFields.map((obj) => {
            if (obj.columnName === selectedItem[0].columnName)
              obj["isTemp"] = false;
            return obj;
          })
        );
      }, 3000);
    } else {
      const selectedItem = inactiveFieldsState.splice(index, 1);

      setActiveFieldsState((activeFieldsState) => [
        ...activeFieldsState,
        ...selectedItem
      ]);

      setComparisonFields(
        comparisonFields.map((obj) => {
          if (obj.columnName === selectedItem[0].columnName) {
            obj.isActive = true;
            obj.isDraft = true;
            obj["isTemp"] = true;
          }
          return obj;
        })
      );
    }
    // Closing search box.
    setSearchTerm("");
    setActiveSearchBox(false);
    setActiveReset(true);
    setActiveUpdate(true);
  };

  const onSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const cancelSearch = () => {
    setActiveSearchBox(false);
  };

  useEffect(() => {
    const result = inactiveFieldsState.filter((item) =>
      item.displayName.toLowerCase().includes(searchTerm)
    );
    setSearchResults(result);
  }, [searchTerm, inactiveFieldsState]);

  useEffect(() => {
    if (activeSearchBox && textInput) {
      textInput.current.focus();
      searchWrapperRef.current.scrollIntoView({ behaviour: "smooth" });
    }
  }, [activeSearchBox, textInput]);

  useEffect(() => {
    updateFromModal && handleUpdate();
    setUpdateFromModal(false);
  }, [updateFromModal]);

  useEffect(() => {
    if (updateReset) {
      handleUpdate();
    }
  }, [updateReset, activeFieldsState]);

  const windowSize = useWindowSize();
  const setFocus = () => {
    setActiveSearchBox(true);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = reorder(
      activeFieldsState,
      result.source.index,
      result.destination.index
    );

    // Getting the corresponding index for the matching columnName in activeFieldsState and comparisonFields (listing)
    let listingSourceIndex, listingDestIndex;

    comparisonFields.forEach((obj, index) => {
      if (obj.columnName == activeFieldsState[result.source.index].columnName)
        listingSourceIndex = index;

      if (
        obj.columnName == activeFieldsState[result.destination.index].columnName
      )
        listingDestIndex = index;
    });

    const comparisonItems = reorder(
      comparisonFields,
      listingSourceIndex,
      listingDestIndex
    );

    setActiveFieldsState(items);
    setComparisonFields(comparisonItems);
    setActiveReset(true);
    setActiveUpdate(true);
  };

  const handleRowHoverEnter = (index) => {
    setComparisonFields(
      comparisonFields.map((obj) => {
        if (obj.columnName === activeFieldsState[index].columnName) {
          obj["isTemp"] = true;
        }
        return obj;
      })
    );
  };
  const handleRowHoverLeave = (index) => {
    setComparisonFields(
      comparisonFields.map((obj) => {
        if (obj.columnName === activeFieldsState[index].columnName) {
          obj["isTemp"] = false;
        }
        return obj;
      })
    );
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const details = {};
      activeFieldsState.forEach((data) => {
        details[data.columnName] = data.value;
      });

      const newSubjectPropertyData = await updateSubjectProperty(
        report.id,
        details,
        photo,
        cropData
      );
      setSubjectProperty((subjectProperty) => ({
        ...subjectProperty,
        ...transformSubjectProperty(newSubjectPropertyData)
      }));

      setShowEditDrawer(false);
      setInactiveFields(inactiveFieldsState);
      setActiveFields(activeFieldsState);

      setToasterMessage({
        status: "success",
        msg: "Comparison details saved."
      });
      setActiveUpdate(false);
    } catch (error) {
      setToasterMessage({
        status: "error",
        msg: "Comparison details could not be saved."
      });
    }

    setLoading(false);
  };

  const handleValueChange = (e, index) => {
    activeFieldsState[index].value = e.target.value;
    setActiveUpdate(true);
  };

  const handleDeleteSubjectPropertyImage = () => {
    deleteSubjectPropertyPhoto(report.id, subjectProperty.id);
    setPhoto(null);
    setPhotoExists(false);
    setActiveUpdate(true);
  };

  return (
    <DrawerContent>
      <div className="top-fixed-section">
        <DrawerHeader>
          <h3>Subject Property Details</h3>
        </DrawerHeader>
        <PhotoWidgetContainer
          style={{
            display: windowSize.width <= 576 && activeSearchBox && "none"
          }}>
          {!photoExists ? (
            <MapStatic
              style={{
                height: "210px"
              }}
              lat={subjectProperty.coords.lat}
              lon={subjectProperty.coords.lon}
              pin={<SubjectPropertyPin color={theme.live.colors.primary} />}
            />
          ) : null}
          <PhotoCellContainer style={{ top: photoExists && "0px" }}>
            <PhotoCell
              style={{
                width: !photoExists ? "120px" : "100%",
                height: !photoExists ? "30px" : "100%",
                padding: "0px"
              }}>
              <PhotoSelector
                id="photo"
                name="subject_property"
                previewUrl={subjectProperty.photo}
                onCrop={({ data, files }) => {
                  setCropData(data);
                  setPhoto(files[0]);
                  setPhotoExists(true);
                  setActiveUpdate(true);
                }}
                onDelete={handleDeleteSubjectPropertyImage}
              />
            </PhotoCell>
          </PhotoCellContainer>
        </PhotoWidgetContainer>

        <ComparableAddress
          style={{
            background: `${theme.styleGuide.colors.white}`,
            display: windowSize.width <= 576 && activeSearchBox && "none"
          }}
          street={subjectProperty.street}
          cityStateZip={subjectProperty.cityStateZip}
          status="Subject"
          statusColor={theme.styleGuide.colors.purple[500]}
          price={0}
          isSubjectProperty
        />
      </div>
      <div id="middle-scrollable-section">
        {resetConfirm ? (
          <ResetToDefaultContainer>
            <h3>Reset to Default?</h3>
            <div>This will reset comparable fields</div>
            <div className="end-of-block">and data back to default.</div>
            <div>
              <Button variant="secondary" onClick={handleCancelReset}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleConfirmReset}>
                Reset to default
              </Button>
            </div>
          </ResetToDefaultContainer>
        ) : (
          <>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {activeFieldsState.map((field, index) => (
                      <Draggable
                        key={field.columnName}
                        draggableId={field.columnName}
                        index={index}>
                        {(provided) => (
                          <div
                            onMouseEnter={() => handleRowHoverEnter(index)}
                            onMouseLeave={() => handleRowHoverLeave(index)}
                            ref={provided.innerRef}
                            {...provided.draggableProps}>
                            <div>
                              {confirmDelete === index ? (
                                <DeleteWrapper>
                                  <div {...provided.dragHandleProps}></div>
                                  <Button variant="secondary" onClick={keepRow}>
                                    Keep
                                  </Button>
                                  <Button
                                    variant="danger"
                                    onClick={() => removeRow(index)}>
                                    Remove
                                  </Button>
                                </DeleteWrapper>
                              ) : (
                                <ActiveList
                                  style={{
                                    display:
                                      windowSize.width <= 576 &&
                                      activeSearchBox &&
                                      "none"
                                  }}>
                                  <div
                                    {...provided.dragHandleProps}
                                    style={{
                                      width: "44px",
                                      paddingTop: "8px"
                                    }}>
                                    <IconDrag height="20px" width="20px" />
                                  </div>
                                  <div>{field.displayName}</div>
                                  <div>
                                    <Input
                                      index={index}
                                      defaultValue={
                                        field.value ? field.value : ""
                                      }
                                      onChange={(e) =>
                                        handleValueChange(e, index)
                                      }
                                      type="text"></Input>
                                  </div>
                                  <div>
                                    <IconTrashCan
                                      style={{
                                        fill: "#E51125",
                                        height: "44px",
                                        width: "44px",
                                        padding: "5px"
                                      }}
                                      onClick={() =>
                                        deletefromActiveList(index)
                                      }
                                    />
                                  </div>
                                </ActiveList>
                              )}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            {activeSearchBox ? (
              <div ref={searchWrapperRef}>
                <div className="search-for-fields" ref={detectOutClickRef}>
                  <div className="search-box-wrapper">
                    {searchTerm.length > 0 && (
                      <IconClosePill
                        className="close-icon"
                        onClick={() => setSearchTerm("")}
                      />
                    )}
                    <Input
                      className="search-box"
                      placeholder="Search for comparison field"
                      ref={textInput}
                      type="text"
                      onChange={onSearchChange}
                      value={searchTerm}
                    />

                    <a
                      className="cancel-button"
                      type="button"
                      onClick={cancelSearch}>
                      Cancel
                    </a>
                  </div>

                  <div className="fields-list">
                    {searchResults.length > 0 ? (
                      searchResults.map((field, index) => (
                        <div
                          key={index}
                          onClick={() => pushToActive(index)}
                          className="search-result">
                          <div>{field.displayName}</div>
                          <div>{field.value}</div>
                        </div>
                      ))
                    ) : (
                      <div className="no-search-result">
                        <h3 className="title">
                          No results found for <br />"{searchTerm}"
                        </h3>
                        <p className="description">
                          Please make sure your words are <br />
                          spelled correctly or use less or <br />
                          different keywords.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="add-comparison" onClick={() => setFocus()}>
                <IconPlus
                  style={{
                    fill: "#4775d1",
                    width: "16px",
                    marginRight: "6px",
                    padding: "20px 0"
                  }}
                />
                Add Comparison Row
              </div>
            )}

            {activeReset ? (
              <div className="reset-default" onClick={() => resetToDefault()}>
                Reset to Default
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </div>

      <div
        className="footer-content"
        style={{
          display: windowSize.width <= 576 && activeSearchBox && "none"
        }}>
        <Button
          variant="secondary"
          className="cancel-btn"
          onClick={handleCancel}>
          Cancel
        </Button>

        <Button
          className="update-btn"
          onClick={handleUpdate}
          disabled={activeUpdate ? false : true}>
          Update
        </Button>
      </div>
    </DrawerContent>
  );
}

function useDetectOutClick(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
}

export default LiveListingSubjectPropertyDrawer;

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};
